import Bowser from "bowser";

export interface TrackingMetadata {
  referrer?: string;
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  utmContent?: string;
  utmTerm?: string;
  userAgent?: string;
  device?: string;
  browser?: string;
  os?: string;
  locale?: string;
  country?: string;
}

export async function getTrackingMetadata(): Promise<TrackingMetadata> {
  const params = new URLSearchParams(window.location.search);
  const agent = Bowser.parse(navigator.userAgent);
  const country = await resolveCountry();

  return {
    referrer: document.referrer || undefined,
    utmSource: params.get("utm_source") || undefined,
    utmMedium: params.get("utm_medium") || undefined,
    utmCampaign: params.get("utm_campaign") || undefined,
    utmContent: params.get("utm_content") || undefined,
    utmTerm: params.get("utm_term") || undefined,
    userAgent: navigator.userAgent || undefined,
    device: agent.platform.type || undefined,
    browser: agent.browser.name || undefined,
    os: agent.os.name || undefined,
    locale: navigator.language || undefined,
    country,
  };
}

async function resolveCountry(): Promise<string | undefined> {
  try {
    const ipResponse = await fetch("https://api.ipify.org?format=json");
    if (!ipResponse.ok) return undefined;
    const { ip } = await ipResponse.json();
    const geoResponse = await fetch(`https://iplocate.io/api/lookup/${ip}`);
    if (!geoResponse.ok) return undefined;
    const data = await geoResponse.json();
    return data.country_code || undefined;
  } catch {
    return undefined;
  }
}
